import "./index.css"

export default function Spinner({className, ...props}) {

    return (
        <div className={`spinner ${className}`}/>

    )
}